import { t9n } from 't9n/t9n'

import { NewsletterError, NewsletterResponse } from 'models/endpoints-respone'
import { FormElements } from '../models/form-elements'

import { pushDataLayer } from 'utils/data-layer-push'

import { signUpForNewsletter, signUpForCurrencyCommentsNewsletter } from 'services/newsletter-service'
import { ConsentType } from 'models/newsletter'

import { setInputErrorMSG, setErrorMSG } from './form-handling'

const handleApiError = (error: NewsletterError, formElements: FormElements): void => {
  const { data } = error.response
  switch (data) {
    case 'ALREADY_SUBSCRIBED':
      setInputErrorMSG(
        '[data-newsletter-rodo]',
        t9n('formValidation.newsletterAlreadySubscribed'),
        formElements.$formContainerParent,
      )
      break
    case 'INVALID_EMAIL':
      setInputErrorMSG('[data-email-field]', t9n('formValidation.emailNotValid'), formElements.$formContainerParent)
      break
    case 'INVALID_LIST':
      setErrorMSG('[data-error-server]', t9n('formValidation.serverUnknownError'), formElements.$formContainerParent)
      console.error('Invalid list', error)
      break
    default:
      setErrorMSG('[data-error-server]', t9n('formValidation.serverUnknownError'), formElements.$formContainerParent)
      console.error('Unexpected error:', error)
      break
  }
}

export const handleNewsletterSubscription = async (
  formElements: FormElements,
  consentType: ConsentType = 'default',
): Promise<NewsletterResponse> => {
  const { $emailField, $formContainerParent } = formElements
  const email = $emailField?.value ?? ''
  const rodoElement = $formContainerParent.querySelector<HTMLInputElement>('[data-newsletter-rodo]')

  if (!email || !rodoElement || !$formContainerParent) {
    throw new Error('Form validation failed or required fields are missing.')
  }

  const datasetConsent = rodoElement.dataset.newsletterConsent as ConsentType | undefined
  if (datasetConsent) consentType = datasetConsent

  try {
    const response =
      consentType === 'currencyComments'
        ? await signUpForCurrencyCommentsNewsletter({ email })
        : await signUpForNewsletter({ email })

    pushDataLayer('form_submitted', { form_name: 'Zapis do Newslettera' })
    return response
  } catch (error: unknown) {
    console.error('Error during newsletter subscription:', error)
    handleApiError(error as NewsletterError, formElements)
    throw error
  }
}
